import React from 'react'
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Button, IconButton,  } from '@mui/material';
import Styles from "../../../Styles/Resume.module.css"
import TopBar from "../../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../../Components/LayoutWapper/Global/SideBar";
import Back from "../../../Assets/back.png";
import Profile from "../../../Components/ResumeForm/Profile"
import Experience from '../../../Components/ResumeForm/Experience';
import Education from '../../../Components/ResumeForm/Education'
import Skills from '../../../Components/ResumeForm/SKills'
import Certify from '../../../Components/ResumeForm/Certify'
import Links  from '../../../Components/ResumeForm/Links';







function Index() {

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }


  return  (
      <div className={Styles.container}>
      <TopBar toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <Link to='/resume' style={{ textDecoration:"none", color:"black"}}> 
        <div className={Styles.navigation} style={{ position:"relative", right:"30px"}}> 
      <IconButton disableRipple><img src={Back} alt=""  width="18.34px" height="15.35px"/></IconButton>
          <span>Back</span>
        </div>
        </Link>
         <div className={Styles.resumecontainer}>
          <div className={Styles.resumecontents}>
           <Profile/>
           <Experience/>          
           <Education/>
            <Skills/>
            <Certify/>
            <Links/>
           
          </div>
         </div>
         <Button sx={{ width:"150px" , height:"60px", background:"rgba(243, 114, 63, 1)", borderRadius:"10px", color:"white", position:"relative", left:"37.5rem", top:"20px","&:hover": { backgroundColor:"rgba(243, 114, 63, 1)"} }}>
          Download
         </Button>
        </div>
          </div>
          </div>
         </div>
       </div> 
       
      
  )
}

export default Index;